
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"45.175","height":"43.152"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Calque 2"}},[_c('g',{attrs:{"data-name":"Group 58","fill":"#172a55"}},[_c('path',{attrs:{"data-name":"Path 57","d":"M37.821 23.002h-1a2.01 2.01 0 01-1-2c1.117-3.517.64-6.422-2-9-2.653-2.64-6.445-4.17-10-3a2.106 2.106 0 01-2-1 1.32 1.32 0 010-1c.151-.3.679.1 1 0a13.2 13.2 0 0113 3 11.475 11.475 0 013 12c-.15.514-.461.984-1 1z"}}),_c('path',{attrs:{"data-name":"Path 58","d":"M43.825 23.001h-1c-.31-.063-.832.269-1 0a1.393 1.393 0 010-1 15.351 15.351 0 00-4-14 15.374 15.374 0 00-14-4 1.393 1.393 0 01-1 0c-.269-.168-.937-.69-1-1a1.393 1.393 0 010-1c.168-.269.69-.937 1-1 5.885-1.3 12.614.864 17 5a17.3 17.3 0 015 16c-.153.514-.465.984-1 1z"}}),_c('path',{attrs:{"data-name":"Path 59","d":"M32.824 43.007c-16.6 0-28.361-15.727-32-27a12.323 12.323 0 011-11c1.953-2.84 6.781-4.822 9-5 .451-.04.813.588 1 1l5 10c.247.463.353.612 0 1l-4 5c2.451 6.517 7.563 12.346 14 15l4-6a2.232 2.232 0 012 0l10 6c.333.17 1.007.627 1 1 .355 3.2-1.3 9.024-6 10-1.635.339-3.329-.015-5 0zm-23-41a9.248 9.248 0 00-6 4 10.287 10.287 0 00-1 9c2.4 7.1 12.958 26 30 26 1.55.024 2.483-.681 4-1 3.107-.621 4.911-3.87 5-6l-9-5-5 5c-.325.325-.552.1-1 0a28.413 28.413 0 01-17-17c-.123-.448-.341-.685 0-1l5-5z"}})])])])
          )
        }
      }
    